<div class="title">
    Advertisers
</div>

<div class="sub-title">
    Add new advertisers to start running campaigns and track their progress. You can also import an advertiser from one of the data sources you have already connected.
</div>

<div class="search">
    <div class="search-label"><mat-icon>search</mat-icon></div>

    <mat-form-field class="search-field">
        <mat-label>Search data sources</mat-label>
        <input matInput />
    </mat-form-field>

</div>

<div class="table-info">
    <div class="follow-advertiser">Follow advertiser</div>
    <div class="follow-agency">Follow agency</div>
</div>

<!--<form>-->
<!--    <table>-->
<!--        <thead>-->
<!--        <tr>-->
<!--            <th class="name-col"> Name </th>-->
<!--            <th class="email-col"> Email </th>-->
<!--            <th class="role-col"> Roles </th>-->
<!--            <th class="action-col"> Actions </th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->

<!--        <tr>-->
<!--            <td>{{'username'}}</td>-->
<!--            <td>{{'email'}}</td>-->
<!--            <td>-->
<!--                <mat-grid-list class="user-grid-list" cols="3" rowHeight="{{shared.helpers.UtilHelper.px2rem(72)}}">-->
<!--                    <mat-grid-tile>-->
<!--                        <div style="cursor: pointer" class="role-icon{{user.roles.indexOf(shared.dicts.UserRoles.ADMIN) >= 0?' highlight':' disabled'}}" (click)="updateRole(user.id, shared.dicts.UserRoles.ADMIN)">-->
<!--                            <img src="assets/images/admin_{{user.roles.indexOf(shared.dicts.UserRoles.ADMIN) >= 0?'active':'disabled'}}.svg" alt="Admin">-->
<!--                        </div>-->
<!--                    </mat-grid-tile>-->
<!--                    <mat-grid-tile>-->
<!--                        <div style="cursor: pointer" class="role-icon{{user.roles.indexOf(shared.dicts.UserRoles.TRADER) >= 0?' highlight':' disabled'}}" (click)="updateRole(user.id, shared.dicts.UserRoles.TRADER)">-->
<!--                            <img src="assets/images/trader_{{user.roles.indexOf(shared.dicts.UserRoles.TRADER) >= 0?'active':'disabled'}}.svg" alt="Trader">-->
<!--                        </div>-->
<!--                    </mat-grid-tile>-->
<!--                    <mat-grid-tile>-->
<!--                        <div style="cursor: pointer" class="role-icon{{user.roles.indexOf(shared.dicts.UserRoles.AM) >= 0?' highlight':' disabled'}}" (click)="updateRole(user.id, shared.dicts.UserRoles.AM)">-->
<!--                            <img class="" src="assets/images/am_{{user.roles.indexOf(shared.dicts.UserRoles.TRADER) >= 0?'active':'disabled'}}.svg" alt="Account Manager">-->
<!--                        </div>-->
<!--                    </mat-grid-tile>-->
<!--                </mat-grid-list>-->
<!--            </td>-->
<!--            <td class="action-col">-->
<!--                <div class="user-list-action" (click)="resetPassword(user.email);">Reset Password</div>&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--                <div class="user-list-action" (click)="updateUserStatus(user.id, user.email, user.status);">{{getUserActionText(user.status)}}</div>-->
<!--            </td>-->
<!--        </tr>-->
<!--        </tbody>-->

<!--    </table>-->
<!--</form>-->

